import React from 'react';
import { Button, Image, useToast } from '@chakra-ui/react';
import { excelIcon } from '../../assets/new-images/icons';
import baseService from '../../services/base';

const DownloadResponsesButton = ({
 surveyId,
 companyId,
 companyGroupId,
 formName,
 isLoadingResponses,
 setLoadingResponses,
 isCompact = false,
 ...rest
}) => {
 const toast = useToast();

 async function responsesDownload() {
  setLoadingResponses(true);
  try {
   const response = await baseService.get(
    `/excel/download/new?description=${formName}&company_id=${companyId}&survey_id=${surveyId}&company_group_id=${companyGroupId}`,
    {
     responseType: 'blob',
    }
   );

   const url = window.URL.createObjectURL(new Blob([response.data]));
   const link = document.createElement('a');
   link.href = url;
   link.setAttribute('download', `${formName}.xlsx`);
   document.body.appendChild(link);
   link.click();
   window.URL.revokeObjectURL(url);
   document.body.removeChild(link);
   toast({
    title: `Download concluído com sucesso`,
    status: 'success',
    isClosable: true,
   });
  } catch (error) {
   console.error('Erro ao fazer o download:', error);
   toast({
    title: 'Erro ao fazer o download',
    status: 'error',
    isClosable: true,
   });
  } finally {
   setLoadingResponses(false);
  }
 }

 return (
  <Button
   leftIcon={<Image src={excelIcon} alt='' w='22px' h='22px' />}
   variant='outline'
   borderColor='#DEE5E4'
   color='#5C6066'
   bg='white'
   height='51px'
   fontWeight={600}
   _hover={{ bg: '#F1F5FA', borderColor: '#0073BB', color: '#0073BB' }}
   isLoading={isLoadingResponses}
   onClick={responsesDownload}
   {...rest}
  >
   Exportar Excel
  </Button>
 );
};

export default DownloadResponsesButton;
